<mat-progress-bar color="accent" mode="indeterminate" *ngIf="isLoading" style="position:absolute;"></mat-progress-bar>

<div fxFlex="row" fxFlex style="width: 100%;">
    <div fxFlex="240px" class="sidenavigationTop hidexs">
        <div class="iwg-service-name">MyTalent</div>
        <div class="sidenavigationInner">
            <div>
                <button mat-button class="sidenavigationassbtn active-side-nav" layout (click)="OnClickMyTalent()">
                    Profile
                    <span class="textSuccess activeiconcolor"></span>
                </button>
            </div>
            <app-buttonbar></app-buttonbar>
        </div>
    </div>

    <div fxFlex="calc(100% - 240px)" fxFlex.xs="100">
        <div class="content">
            <div class="iwg-page-header-breadcrumb" style="min-height: 34px;">
                <span>MyTalent</span> » <span class="iwg-page-header-small-title">Profile</span>
                <button mat-button class="md-primary md-raised iwg-md-raised"
                           (click)="OnClick('worker-profile')"
                           style="background-color: #224d95;float:right;color: rgba(255,255,255,0.87);box-shadow: 0 2px 5px 0 rgb(0 0 0 / 26%);">
                    Update Profile
                </button>
                <button mat-button class="md-primary md-raised iwg-md-raised"
                            (click)="DeleteProfile()"
                           style="background-color: #224d95;float:right;color: rgba(255,255,255,0.87);margin-right: 10px;box-shadow: 0 2px 5px 0 rgb(0 0 0 / 26%);">
                    Delete Profile
                </button>
            </div>
          

            <div class="iwg-widget-box" style="width: 100%;">
                <div class="iwg-widget-box-bodyNOT" layout="column" style="padding:8px 10px;">
                    <div layout>
                        <div flex style="margin: 8px 8px 8px 8px;font-size: 16px;color: rgba(0,0,0,0.87);">
                            MyTalent
                        </div>
                    </div>
                    <div class="iwg-widget-box-card">
                        <label class="iwg-regular-label">{{ WorkerDisplayName }} Name</label>
                        <p class="iwg-regular-value" style="margin: 0px;">{{ WorkerName}}</p>
                    </div>
                    <div class="iwg-widget-box-card linka">
                        <mat-icon style="color: rgba(0,0,0,0.54);">email</mat-icon>
                        <a href="mailto:{{WorkerInformation?.WorkerEmail}}">{{WorkerInformation?.WorkerEmail}}</a>
                    </div>
                    <div class="iwg-widget-box-card">
                        <label class="iwg-regular-label">Profile </label>
                        <pre class="pre-text-format">{{WorkerInformation?.Profile }}</pre>
                    </div>
                    <div class="iwg-widget-box-card">
                        <label class="iwg-regular-label">Skills </label>
                        <pre class="pre-text-format">{{WorkerInformation?.Skill }}</pre>
                    </div>
                    <div class="iwg-widget-box-card">
                        <label class="iwg-regular-label">LinkedIn URL </label>
                        <div *ngIf="WorkerInformation?.ReferenceURL!=null && WorkerInformation?.ReferenceURL!=''">
                            <a href="{{(WorkerInformation?.ReferenceURL?.indexOf('://') === -1) ? 'https://' + WorkerInformation?.ReferenceURL : WorkerInformation?.ReferenceURL}}"  target="_blank" class="ng-binding"> {{WorkerInformation.ReferenceURL}}</a>
                            <a href="{{(WorkerInformation?.ReferenceURL?.indexOf('://') === -1) ? 'https://' + WorkerInformation?.ReferenceURL : WorkerInformation?.ReferenceURL}}"  target="_blank" class="ng-binding external"></a>
                        </div>
                    </div>
                    <div class="iwg-widget-box-card" style="max-height: 50px;">
                        <label class="iwg-regular-label">Resume File </label>
                        <p class="iwg-regular-value" *ngIf="WorkerInformation?.ResumeFileID!=null">
                            {{WorkerInformation.ResumeFileName }}
                            <button class="mat-icon-button" (click)="downloadResume()">
                                <mat-icon style="color: rgba(0,0,0,0.54);vertical-align: middle;">file_download</mat-icon>
                            </button>
                        </p>
                    </div>
                    <div class="iwg-widget-box-card">
                        <label class="iwg-regular-label">Resume </label>
                        <pre class="pre-text-format">{{WorkerInformation?.ResumeParsed}}</pre>
                    </div>
                </div>
            </div>
        </div>
        <div class="innerpage-footer">
            <app-iwg-footer [blurBg]="true"></app-iwg-footer>
        </div>
    </div>
</div>
